import utils from "@/utils";
import { Controller } from "@hotwired/stimulus";

/** A controller for managing a custom dropdown menu. **/
export default class DropdownController extends Controller<HTMLElement> {

    static targets = ['indicator'];

    declare readonly hasIndicatorTarget: boolean; // Needed for autocomplete, which has no dropdown indicator
    declare readonly indicatorTarget: HTMLElement;

    initialize(): void {
        utils.addAction(this.element, `open->${this.identifier}#open`);
        utils.addAction(this.element, `close->${this.identifier}#close`);
    }

    open() {
        if (this.hasIndicatorTarget) {
            this.indicatorTarget.innerHTML = '▲';
        }
        utils.addController(this.element, 'dropdown-menu');
    }

    close() {
        if (this.hasIndicatorTarget) {
            this.indicatorTarget.innerHTML = '▼';
        }
        utils.removeController(this.element, 'dropdown-menu');
    }

    toggle() {
        return this.isOpen ? this.close() : this.open();
    }

    get isOpen() {
        return utils.hasController(this.element, 'dropdown-menu');
    }
}
